import React from 'react';
import { Typography } from '@mui/material';
import useStyles from './styles';

export default (props) => {
  const { primary, secondary, hideSmallPrimary, ...rest } = props;
  const classes = useStyles();
  return (
    <Typography component={'div'} variant={'body2'} {...rest}>
      <span className={hideSmallPrimary && classes.hideSmall} style={{ fontWeight: 'bold' }}>
        {primary}
      </span>
      {secondary && <>{secondary}</>}
    </Typography>
  );
};
